import $appConfig from "servicestack/config";
// import Media from "webutils/media/media";
import DownloadImagesPrompt from "emun.cart/download-cart-images-prompt";
import Product from "emun.shopping/product.model";

export default class InvoiceLine {
  constructor(dto) {
    Object.assign(this, dto);
    if (dto.product) this.product = new Product(dto.product);
  }
  downloadPrompt(ext) {
     return DownloadImagesPrompt({
       subTitle: this.productId + " - " + this.description,
       id: this.id || this.invoiceId,
       productId: this.productId,
       position: this.position
     });
  }
  img(size, ext) {
    if (this.product && this.product.img) {
      return this.product.img(size);
    }

    return $appConfig.productImage(this.productId, size);
  }
}
